import { Injectable } from '@angular/core';

import { ShippingRegionDetailBanded } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShippingRegionDetailBandedService extends TmsWebBaseEditCreateService<
  ShippingRegionDetailBanded,
  ShippingRegionDetailBanded
> {
  constructor() {
    super('ShippingRegionDetailBanded', $localize`Shipping Region Detail Banded`);
  }
}
